export default __webpack_public_path__ + "static/media/card1.2b1dc140.jpeg";